module.exports = __webpack_public_path__ + "media/images/player/viddsee-logo-28ece576217f400d46f550d9b1f2e50d.svg";